import moment from 'moment'

export const checkValueInStore = (id, value, trackData) => {
  if (!trackData.textValues[id]) {
    if (id === 'LastLogin' || id === 'LastUpdate') {
      trackData.textValues[id] = value === null || !value
        ? ''
        : moment(value).format('MM/DD/YYYY hh:mm A')
    } else {
      trackData.textValues[id] = value === null || !value ? '' : value
    }
    return trackData.textValues[id]
  } else {
    return trackData.textValues[id]
  }
}



// WEBPACK FOOTER //
// ./src/components/AdditionalReportFilters/helpers.js